<template>
	<div
		class="c-reviews"
		:class="'c-reviews--' + version"
		v-if="!isLoading"
		id="reviews"
	>
		<div
			class="c-reviews__details"
			:class="isOpen ? 'c-reviews__details--active' : ''"
		>
			<div class="heading">
				<slot name="header"></slot>
				<Rating number="rating" :review="reviewData"></Rating>
			</div>
			<button
				:aria-label="translations['Write a review']"
				class="o-btn o-btn--outline button"
				@click="changeIsOpen"
			>
				<span>{{ translations["Write a review"] }}</span>
			</button>
		</div>

		<ReviewCreate
			:isOpen="isOpen"
			:id="id"
			@change-open="changeIsOpen"
			ref="create"
		></ReviewCreate>

		<div class="c-reviews__reviews">
			<div class="block-amount" v-if="version == 'block'">
				{{ translations["Reviews"] }} ({{ reviewData.amount }})
			</div>
			<Review v-for="item in reviewItems" :data="item"></Review>
		</div>

		<div class="c-reviews__load" v-if="reviewData.amount >= amount">
			<button
				:aria-label="translations['Show more reviews']"
				class="o-btn o-btn--outline"
				@click="fetchMoreReviews"
			>
				<span v-if="!moreLoading">{{ translations["Show more reviews"] }}</span>
				<Loader v-if="moreLoading" color="blue"></Loader>
			</button>
		</div>
	</div>

	<div class="c-reviews--loading" v-if="isLoading">
		<Loader color="blue"></Loader>
	</div>
</template>

<script>
//Mixins
import request from "@/vue/mixins/request.js";
import * as map from "@/vue/mixins/map";

import Rating from "../objects/Rating.vue";
import Review from "../objects/Review.vue";
import ReviewCreate from "../commerce/objects/ReviewCreate.vue";
import Loader from "../objects/Loader.vue";
import InteractiveRating from "../objects/InteractiveRating.vue";
import FieldInput from "../fields/FieldInput.vue";
import FieldArea from "../fields/FieldArea.vue";
import FieldCheckbox from "../fields/FieldCheckbox.vue";

export default {
	name: "Reviews",
	mixins: [map.site, map.cart, request],
	props: {
		id: {
			type: Number,
			default: 0,
		},
		version: {
			type: String,
			default: "compact",
		},
	},
	components: {
		//Objects
		Review,
		ReviewCreate,
		Rating,
		Loader,
		InteractiveRating,
		FieldInput,
		FieldArea,
		FieldCheckbox,
	},
	data: () => {
		return {
			reviewItems: [],
			reviewData: [],
			totalReviews: 0,
			averageRating: 0,
			amount: 3,

			isOpen: false,
			isLoading: false,
			moreLoading: false,

			description: "",
			name: "",
			rememberMe: false,
		};
	},
	methods: {
		fetchReviews() {
			if (!this.moreLoading) {
				this.isLoading = true;
			}

			const url = this.endpoint.getReviews + this.id + "/" + this.amount;
			this.getRequest(url).then(() => {
				this.reviewItems = this.res.data.items;
				this.reviewData = this.res.data.rating;

				this.isLoading = false;
				this.moreLoading = false;
			});
		},
		fetchMoreReviews() {
			this.amount += 3;
			this.moreLoading = true;
			this.fetchReviews();
		},
		changeIsOpen() {
			this.$refs.create.valid = true;
			this.$refs.create.rating = "";
			this.$refs.create.name = "";
			this.$refs.create.description = "";
			this.$refs.create.success = false;

			this.isOpen = !this.isOpen;
		},
	},
	created() {
		this.fetchReviews();
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-reviews {
	display: flex;
	flex-direction: column;

	&__details {
		display: flex;
		justify-content: space-between;
		padding-top: 8px;

		.heading {
			.product {
				font-weight: $f-semibold;
				margin-bottom: 8px;
			}
		}

		.o-btn {
			width: 100%;
		}
		&--active {
			.o-btn {
				display: none;
			}
		}
	}
	&__post {
		margin-bottom: 24px;
		.review-item {
			margin: 8px 0;
			span {
				color: $c-red;
			}
		}
		.post-rating {
			margin-bottom: 14px;
		}
		.save {
			margin-bottom: 32px;
		}
	}
	&__post {
		margin-bottom: 24px;
		.review-item {
			margin: 8px 0;
			span {
				color: $c-red;
			}
		}
		.post-rating {
			margin-bottom: 14px;
		}
		.save {
			margin-bottom: 32px;
		}
	}

	&__seperator {
		border-bottom: $e-border;
		padding-bottom: 16px;
		margin-bottom: 40px;
	}

	&__load {
		margin-top: 24px;
		margin-bottom: 47px;
		width: 100%;
		display: flex;
		justify-content: center;

		.o-btn {
			width: fit-content;
		}
	}

	&--compact {
		.c-reviews {
			&__details {
				padding-bottom: 20px;
				.heading {
					display: none;
				}
				&--active {
					display: none;
				}
			}
			&__reviews {
				.co-review {
					border-top: 1px solid $c-grey;
				}
				.block-amount {
					margin-bottom: 16px;
				}
			}
			&__reviews {
				.co-review {
					border-top: 1px solid $c-grey;
				}
				.block-amount {
					margin-bottom: 16px;
				}
			}
		}
	}

	&--block {
		margin-top: 12px;
		margin-bottom: 38px;
		.c-reviews {
			&__details {
				padding-bottom: 32px;
				.c-rating {
					&__icons {
						gap: 7px;
					}
				}
			}
			&__reviews {
				.co-review {
					border-top: 1px solid $c-grey;
					&:last-child {
						border-bottom: 1px solid $c-grey;
					}
				}
				.block-amount {
					margin-bottom: 16px;
				}
			}
		}
	}
	&--loading {
		margin: 50px 0;
	}
}

@media all and (max-width: 1100px) {
	.c-reviews {
		&--block {
			.c-reviews {
				&__details {
					padding-bottom: 40px;

					.c-rating {
						&__icons {
							gap: 4px;

							svg {
								width: 15px;
								height: 15px;
							}
						}
					}
				}
			}
		}
	}
}

@media all and (max-width: 600px) {
	.c-reviews {
		&__seperator {
			margin-bottom: 24px;
		}
	}
}

@media all and (max-width: 450px) {
	.c-reviews {
		&__details {
			flex-direction: column;
			width: 100%;

			.o-btn {
				width: unset;
				margin-top: 16px;
			}
		}

		&__load {
			.o-btn {
				width: 100%;
			}
		}
	}
}
</style>
